<template lang="pug">
  v-layout(align-start='')
    v-flex
      v-data-table.elevation-1(:headers='headers' item-key='ventas' :items='ventas' :search='search' sort-by='nombre' :loading='loading' loading-text='Cargando, por favor espere...')
        template(v-slot:top='')
          v-toolbar(color='primary', dark)
            v-toolbar-title.justify-center Ventas
            v-divider.mx-4(inset vertical)
            v-spacer
            v-text-field.text-xs-center(v-model='search', label='Búsqueda', single-line hide-details color='success')
            v-spacer
            v-dialog(v-model='dialogShow' scrollable persistent max-width='80%')
              v-card
                v-card-title
                  span.headline {{ formTitleShow }}
                v-card-text
                  v-row
                    v-row
                      v-col(cols='12', sm='6')
                        v-text-field(dense readonly outlined v-model='editedItem.numFactura', label='Numero de Factura')
                      v-col.d-flex(cols='12', sm='6')
                        v-text-field(dense readonly outlined v-model='editedItem.tipoVenta', label='Tipo de Venta')
                    //- v-row
                      //- v-col(cols='12', sm='6')
                      //-   v-text-field(dense readonly outlined v-model='editedItem.numControl', label='Numero de Control')
                      //- v-col(cols='12', sm='6')
                      //-   v-text-field(dense readonly outlined label='Vendedor')
                    v-row
                      v-col(cols='12', sm='6')
                        v-text-field(dense readonly outlined v-model='editedItem.fechaVencimiento', label='Fecha de Vencimiento')
                      v-col.d-flex(cols='12', sm='6')
                        v-text-field(dense readonly outlined v-model='editedItem.fechaCreacion', label='Fecha de Creación')
                  v-spacer
                  v-flex(xs12 style='margin-top:10px')
                    ListadoProducto(p='activar', v-model='editedItem.detalleProducto')
                  v-row(class='d-flex justify-end')
                    v-col(cols='4' sm='4' md='4')
                      v-text-field(dense readonly outlined :value='editedItem.subTotal | read', label='Subtotal')
                    //- v-col(cols='4' sm='4' md='4')
                    //-   v-text-field(dense readonly :value='editedItem.gravado | read', outlined label='Gravado')
                    //- v-col(cols='4' sm='4' md='4')
                    //-   v-text-field(dense readonly :value='editedItem.exento | read', outlined label='Exento')
                    //- v-row(class='d-flex justify-end')
                    v-col(cols='4' sm='4' md='4')
                      v-text-field(dense readonly v-model='editedItem.total' outlined label='Total + IVA')
                    //- v-col(cols='4' sm='4' md='4')
                    //-   v-text-field(dense readonly :value='editedItem.total | read', outlined label='Total + IVA')
                v-card-actions
                    v-spacer
                    v-btn(color='error' small dark @click='close')
                      v-icon mdi-close
                      | Cerrar
        template(v-slot:item.action='{ item }')
          v-tooltip(bottom='')
            template(v-slot:activator='{ on }')
              v-icon.mr-2(color='primary_2', @click='showItem(item)' v-on="on") mdi-eye
            | Visualizar
          v-tooltip(bottom='')
            template(v-slot:activator='{ on }')
              v-icon.mr-2(@click='exportPDF(item)' color='primary_2' v-on="on") mdi-pdf-box
            | Generar PDF
        template(v-slot:no-data='')
          h1 No hay datos de ventas asociadas
</template>

<script>
import Api from '@/services/methods'
import jspdf from 'jspdf'
import JspdfAutotable from 'jspdf-autotable'

import ListadoProducto from '../components/ListadoProducto'
import { thisExpression } from 'babel-types'
export default {
  name: 'pdf',

  data: () => ({
    dialog: false,
    dialogShow: false,
    dialogPedido: false,
    modalEmi: false,
    loading: true,

    items: ['Credito', 'Debito'],
    dateEmision: new Date().toISOString().substr(0, 10),
    dialog1: false,
    selectedPedido: [],
    select: [],
    pedido: [],
    headers: [
      {
        text: 'Factura',
        align: 'left',
        sortable: false,
        value: 'numFactura'
      },
      { text: 'Cliente', value: 'idPedido.idCliente.nombre' },
      { text: 'Fecha de vencimiento', value: 'fechaVencimiento' },
      { text: 'Monto Total', value: 'total' },
      { text: 'Tipo de Venta', value: 'tipoVenta' },
      { text: 'Estatus', value: 'estatus' },
      { text: 'Acciones', value: 'action', align: 'right', sortable: false }
    ],
    cliente: [],
    idClienteArray: [],
    clientePedido: [],

    vendedor: [],
    idVendedorArray: [],

    search: '',
    permisosRuta: {},
    ventas: [],
    editedIndex: -1,
    editedItem: {
      numFactura: 0,
      fechaCreacion: '',
      fechaVencimiento: '',
      tipoVenta: '',
      // numControl: 0,
      total: 0,
      exento: 0,
      gravado: 0,
      subTotal: 0,
      idPedido: [],
      codigoPedido: '',
      detalleProducto: [],
      estatus: ''
    },
    defaultItem: {
      numFactura: 0,
      fechaCreacion: '',
      fechaVencimiento: '',
      tipoVenta: '',
      // numControl: 0,
      total: 0,
      exento: 0,
      gravado: 0,
      subTotal: 0,
      idPedido: [],
      codigoPedido: '',
      detalleProducto: [],
      estatus: ''
    }
  }),

  components: {
    ListadoProducto,
    JspdfAutotable
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nueva Venta' : 'Modificar Venta'
    },
    formTitleShow () {
      return 'Información de la Venta'
    }
  },
  watch: {
    // dialog(val) {
    //   val || this.close();
    //   console.log(this.editedItem.idCliente.nombre);
    //   console.log(this.editedItem.idVendedor.nombreVendedor);
    // },
    // dialogShow(val) {
    //   val || this.close();
    //   console.log(this.editedItem.idCliente.nombre);
    //   console.log(this.editedItem.idVendedor.nombreVendedor);
    // }
  },
  created () {
    this.initialize()
  },

  methods: {
    exportPDF (item) {
      this.editedIndex = this.ventas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      var today = new Date()
      var date = today.getDate() + '-' + (today.getMonth() + 1) + '-' + today.getFullYear()
      var columns = [
        { title: 'Cantidad', dataKey: 'cantidad' },
        { title: 'Descripción', dataKey: 'descripcion' },
        { title: 'Ref', dataKey: 'ref' },
        { title: 'Código', dataKey: 'codigo' },
        { title: 'Total', dataKey: 'total' }
      ]
      let acumSubtotal = 0
      let acumCantidad = 0
      let contenido = []
      for (let i = 0; i < item.detalleProducto.length; i++) {
        contenido.push({ cantidad: item.detalleProducto[i].despachada,
          ref: item.detalleProducto[i].precio,
          total: item.detalleProducto[i].subTotal,
          descripcion: item.detalleProducto[i].idProducto.descripcion,
          codigo: item.detalleProducto[i].idProducto.nombre })
        acumSubtotal += item.detalleProducto[i].subTotal
        acumCantidad += item.detalleProducto[i].despachada
      }
      var imagen = 'data:image/jpeg;base64,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'

      var doc = new jspdf('p', 'pt')
      doc.autoTable(columns, contenido, {
        didDrawPage: function (data) {
          doc.addImage(imagen, 'PNG', 50, 20, 140, 80)

          doc.setFontSize(10)
          doc.setFont('times')
          doc.setFontType('italic')
          doc.text(300, 30, 'Carrera  1-A  entre calles 2 y 4  Galpón 4  Zona  Industrial II ')
          doc.text(440, 40, 'Barquisimeto, Estado Lara')
          doc.text(440, 50, 'Telf. 0251-2692309 / 2547')
          doc.text(415, 60, 'e-mail: dimzaferry@hotmail.com')
          doc.text(440, 70, 'Web: www.dimzaferry.com')

          doc.setFontSize(15)
          doc.text(400, 90, 'Barquisimeto;' + date)

          doc.setFontSize(10)
          doc.text(40, 160, 'Señores')
          /* doc.text(80, 170, idPedido.idCliente.nombre) */
          doc.text(40, 170, item.idPedido.idCliente.nombre + '    ' + item.idPedido.idCliente.rif)
          doc.text(40, 180, item.idPedido.idCliente.direccion)

          doc.setFontSize(22)
          doc.text(220, 210, 'Nota de Entrega')

          doc.setFontSize(15)
          doc.text(310, (item.detalleProducto.length * 25) + 255, 'PENDIENTE POR PAGAR:' + acumSubtotal)

          doc.setFontSize(15)
          doc.text(40, (item.detalleProducto.length * 25) + 255, 'TOTAL DE PARES:' + acumCantidad)
        },
        theme: 'grid',
        margin: { top: 220 },
        headStyles: { fillColor: 'indigo' }
      })
      doc.save('contenido.pdf')
    },

    formato (fecha) {
      return this.$moment(fecha).format('YYYY-MM-DD, HH:mm')
    },
    functionBs (val) {
      return 'BsS ' + Number.parseFloat(val).toFixed(2)
    },

    Pedido () {
      this.dialogPedido = !this.dialogPedido
      this.listarPedidos()
    },
    initialize () {
      this.listarVentas()
      // this.listarCliente();
      // this.listarVendedor();
      this.permisosRuta = this.$store.state.empresa[0].permisos.find(
        permiso => permiso.ruta == 'Venta'
      )
    },

    validarCrear () {
      return this.permisosRuta.accion.includes('Crear')
    },
    validarModificar () {
      return this.permisosRuta.accion.includes('Modificar')
    },
    validarEliminar () {
      return this.permisosRuta.accion.includes('Eliminar')
    },

    listarVentas () {
      Api.get('/venta/cancelada')
        .then(response => {
          this.ventas = response.data
          this.ventas.map(data => {
            data.fechaCreacion = this.formato(data.fechaCreacion)
            data.fechaVencimiento = this.formato(data.fechaVencimiento)
            data.total = this.functionBs(data.total)
          })
          this.loading = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              //text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    // listarCliente() {
    //   Api.get("/cliente")
    //     .then(response => {
    //       this.cliente = response.data;
    //       console.log(this.cliente);
    //       this.cliente.map(data => {
    //         this.idClienteArray.push({
    //           text: data.nombre,
    //           value: data._id
    //           });
    //       });
    //       console.log(this.idClienteArray)
    //     })
    //     .catch(e => {
    //       console.log("error" + e);
    //     });
    // },
    // listarVendedor() {
    //   Api.get("/vendedor")
    //     .then(response => {
    //       this.vendedor = response.data;
    //       this.vendedor.map(data => {
    //         this.idVendedorArray.push({
    //           text: data.nombreVendedor,
    //           value: data._id
    //         });
    //       });
    //     })
    //     .catch(e => {
    //       console.log("error" + e);
    //     });
    // },
    listarPedidos () {
      Api.get('pedido')
        .then(res => {
          this.pedido = res.data
          this.select = []
          this.pedido.map(data => {
            this.select.push({
              text: data.codigoPedido,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              //text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },
    // CargarVenta(ped) {
    //   console.log('pedido')
    //   console.log(ped)
    //   this.pedido.map(data => {
    //     if(data.codigoPedido === ped){
    //       this.idClienteArray.map(cli => {
    //         console.log(cli.value)
    //         console.log(data.idCliente)
    //         if(cli.value === data.idCliente){
    //           this.clientePedido.push({
    //             text: cli.text,
    //             value: cli.value
    //             });
    //           this.editedItem.codigoPedido = data.codigoPedido
    //           this.editedItem.detalleProducto = data.detalleProducto
    //           this.editedItem.idCliente = this.clientePedido
    //           console.log(this.editedItem)
    //           this.editItem(this.editedItem)
    //         }
    //       })
    //     }
    //   });
    //   this.dialogPedido = false
    // },
    editItem (item) {
      this.editedIndex = this.ventas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
      this.dialogPedido = false
    },
    showItem (item) {
      this.editedIndex = this.ventas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogShow = true
    },
    deleteItem (item) {
      const index = this.ventas.indexOf(item)
      this.$swal({
        icon: 'warning',
        title: '¿Seguro que quiere borrar?',
        text: 'No podrá revertir',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, borrar',
        cancelButtonText: 'cancelar'
      }).then(result => {
        if (result.value) {
          this.$swal('Borrado!', 'Su registro fue borrado.', 'success')
          this.ventas.splice(index, 1)
          Api.delete('/venta/' + item._id).then(response => {
            console.log(response)
          })
        }
      })
    },
    close () {
      this.dialog = false
      this.dialogShow = false
      this.clientePedido = []
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    validarCampos () {
      if (
        this.editedItem.numFactura == '' ||
        this.editedItem.numFactura < 0 ||
        this.editedItem.cliente == '' ||
        this.editedItem.vendedor == '' ||
        this.editedItem.tipoVenta == ''
      ) {
        this.$swal({
          icon: 'error',
          title: 'Verifique todos los campos'
        })
        return true
      }
      return false
    },
    permissDenied (status) {
      if (status == '403') {
        this.$swal({
          icon: 'error',
          title: 'Permiso denegado',
          text: 'No tiene pemisos suficientes para ver esta página',
          allowOutsideClick: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ok',
          onAfterClose: () => {
            window.location.href = '/home'
          }
        })
      }
    },
    save () {
      if (!this.validarCampos()) {
        if (this.editedIndex > -1) {
          Api.put('/venta', this.editedItem)
            .then(response => {
              this.$swal({
                icon: 'success',
                title: 'Modificacion exitosa',
                text: 'Todos los cambios han sido efectuados'
              })
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al modificar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message);
              }
            })

          Object.assign(this.ventas[this.editedIndex], this.editedItem)
        } else {
          Api.post('/venta', this.editedItem)
            .then(response => {
              this.$swal({
                icon: 'success',
                title: 'Inclusion exitosa',
                text: 'Todos los datos han sido guardados'
              })
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message);
              }
            })
          this.listarVentas()
          /* this.ventas.push(this.editedItem); */
        }
        this.close()
      }
    }
  }
}
</script>
